// eslint-disable-next-line @typescript-eslint/no-explicit-any

import { ENV } from 'src/environment';
import { config } from './config';

declare global {
  interface Window {
    analytics: SegmentAnalytics.AnalyticsJS;
  }
}

function identify(
  userId?: string,
  traits?: { first_name: string; last_name: string; lead_status: string; name: string; phone: string } | undefined,
) {
  // if (ENV === 'development') return;
  window.analytics.identify(userId, traits as Record<string, unknown>);
}

function load() {
  window.analytics.load(config.writeKey);

  // Set local segment debugger on in development
  if (ENV === 'development') window.analytics.debug(true);
}

function page() {
  // if (ENV === 'development') return;
  window.analytics.page();
}

// Segment's recommendation when logging a user out or needed to flush things
// https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#load
function reset() {
  window.analytics.reset();
}

function track(name: string, properties?: any) {
  // if (ENV === 'development') return;
  window.analytics.track(name, properties);
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    // See: https://app.segment.com/concreit/sources/web_apps/overview
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'segment';
    script.innerText = `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${config.writeKey}";analytics.SNIPPET_VERSION="4.15.3";analytics.load("${config.writeKey}");analytics.page();}}();`;
    document.head.appendChild(script);
    hasInitialized = true;
  }
  return {
    identify,
    load,
    page,
    reset,
    track,
  };
})();
